module.exports = __webpack_public_path__ + "img/show_labels_Blue_24dp.84d58f8f.svg";